import { ApiResponseModel } from '../types/ApiResponseModel';
import { DataRequestConfig } from '../types/DataRequestConfig';
import { getApiBaseUrl } from './app.service';
import { executeApiRequest, getAuthToken } from './base.service';
import { getHttpClient, HttpClient } from './httpClient';

export const activeSchoolYearsApiPaths = {
  getActiveSchoolYears: () =>
    `common/activeSchoolYears`,
};

export const activeSchoolYearsServiceClient = (
  config?: DataRequestConfig
): HttpClient =>
  getHttpClient(getApiBaseUrl(), getAuthToken() || '', config?.signal);

export const getActiveSchoolYears = async (
  config?: DataRequestConfig
): Promise<ApiResponseModel<string[]>> => {
  return executeApiRequest<string[]>(async () => {
    return await activeSchoolYearsServiceClient(config).get(
      activeSchoolYearsApiPaths.getActiveSchoolYears()
    );
  });
};

